import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

import {
  DashboardAdminCountType,
  DashboardCompanyCountType,
  DashboardFinancialAgencyCountType,
} from '@type-def_iqfu/DashboardType';

import { UserType } from '@constants_common';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export const useDashboardData = () => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const getAdminDashboardData = async (): Promise<DashboardAdminCountType> => {
    const url = `${backendBasePath}/admin/dashboards/notification_counts`;

    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const getCompanyDashboardData = async (): Promise<DashboardCompanyCountType> => {
    const url = `${backendBasePath}/company/dashboards/notification_counts`;

    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const getFinancialAgencyDashboardData = async (): Promise<DashboardFinancialAgencyCountType> => {
    const url = `${backendBasePath}/financial_agency/dashboards/notification_counts`;

    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const getSaleCasesMonthlyCounts = async (userType: UserType) => {
    const url = `${backendBasePath}/${userType}/sale_cases/monthly_counts`;

    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });

    return result;
  };

  return {
    getAdminDashboardData,
    getCompanyDashboardData,
    getFinancialAgencyDashboardData,
    getSaleCasesMonthlyCounts,
  };
};
